const FEATURES = [
  {
    icon: 'ri-shield-check-line',
    title: 'End-to-End Security',
    description:
      'Every product we build starts with security as the foundation. We implement AES-256 encryption, secure tunneling protocols, and rigorous data protection standards to ensure your information is never compromised.',
  },
  {
    icon: 'ri-speed-up-line',
    title: 'Native Performance',
    description:
      'Built exclusively for iOS using native frameworks, our applications are optimized for Apple hardware. No bloat, no compromises — just fast, fluid, and responsive experiences on every supported device.',
  },
  {
    icon: 'ri-eye-off-line',
    title: 'Zero-Log Privacy',
    description:
      'We believe privacy is a fundamental right. Our applications operate on a strict zero-log policy — your activity, location, and data are never stored, sold, or shared with any third parties.',
  },
  {
    icon: 'ri-device-line',
    title: 'iOS-First Design',
    description:
      'Our interfaces are crafted following Apple\'s Human Interface Guidelines — intuitive, clean, and familiar. Users get a seamless experience that feels natural the moment they open the app.',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Dedicated Support',
    description:
      'Our team of experts is always available to assist. Whether it\'s a technical question or account support, we ensure every user receives timely, helpful, and knowledgeable assistance.',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Regular Updates',
    description:
      'The mobile security landscape evolves rapidly. We continuously update our products with new features, performance improvements, and security patches to keep you protected and ahead of threats.',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-24 md:py-36 px-6 md:px-16 bg-[#F7F7F7]">
      {/* Header */}
      <div className="text-center mb-16 md:mb-24">
        <span className="text-emerald-500 text-xs font-semibold tracking-[0.2em] uppercase">Why Choose Us</span>
        <h2 className="mt-3 text-3xl md:text-5xl font-bold text-[#1C1C1E] tracking-tight">Core Features</h2>
        <p className="mt-4 text-[#8E8E93] text-base md:text-lg max-w-xl mx-auto leading-relaxed">
          Every decision we make — from architecture to user interface — is guided by these core principles.
        </p>
        <div className="mt-6 w-14 h-0.5 bg-emerald-500 mx-auto rounded-full" />
      </div>

      {/* Features Grid */}
      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
        {FEATURES.map((feature) => (
          <div
            key={feature.title}
            className="bg-white rounded-2xl p-8 md:p-10 hover:shadow-sm transition-all duration-300 group"
          >
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-emerald-50 group-hover:bg-emerald-500 transition-colors duration-300 mb-6">
              <i className={`${feature.icon} text-emerald-500 group-hover:text-white text-xl transition-colors duration-300`} />
            </div>
            <h3 className="text-lg font-bold text-[#1C1C1E] mb-3">{feature.title}</h3>
            <p className="text-[#6C6C70] text-sm leading-relaxed">{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
